import styles from './OrderModal.module.css';

const OrderModal = ({ order, onClose }) => {
  if (!order) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h2>Order Details</h2>
        <ul className={styles.detailList}>
          <li><strong>ID:</strong> {order.id}</li>
          <li><strong>Order ID:</strong> {order.order_id}</li>
          <li><strong>Side:</strong> {order.side}</li>
          <li><strong>Qty:</strong> {order.qty}</li>
          <li><strong>Price:</strong> {order.price}</li>
          <li><strong>Fee:</strong> {order.fee}</li>
          <li><strong>Type:</strong> {order.order_type}</li>
          <li><strong>Buy Type:</strong> {order.buy_type}</li>
          <li><strong>Status:</strong> {order.exit ? 'Exited' : 'Open'}</li>
          <li><strong>Created At:</strong> {new Date(order.created_at).toLocaleString()}</li>
        </ul>
        <div className={styles.footer}>
          <button onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default OrderModal;
